import { PREMIUM_FEATURES } from '../constants/premium';
import { PageKey } from '../enums/pageKey';

export const isFeaturePremium = (pageKey: PageKey) =>
  PREMIUM_FEATURES.includes(pageKey);
